import { render, staticRenderFns } from "./checkPaymentSuccess.vue?vue&type=template&id=3bfaf481"
import script from "./checkPaymentSuccess.vue?vue&type=script&lang=js"
export * from "./checkPaymentSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports